(function () {
    "use strict";

    // @ngInject
    function CompanySettingsQuickbooksControllerCtor($scope, $injector) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'CompanySettingsQuickbooksController';

    }


    Controllers.CompanySettingsQuickbooksController = Class(Controllers.BaseController, {

        constructor: CompanySettingsQuickbooksControllerCtor,

    });
}());
